import { GetPersonListItemCompanyType as ApiPersonListItemCompanyType } from 'src/api/generated/touring/types';
import { mapAddress, mapContact } from '../../../common';
import { PersonListItemCompanyType } from '../../types';

export const mapPersonListItemCompanyType = (
  apiCompany: ApiPersonListItemCompanyType
): PersonListItemCompanyType => {
  return {
    type: apiCompany.type,
    companyName: apiCompany.companyName || null,
    contact: mapContact(apiCompany.contact),
    address: mapAddress(apiCompany.address),
  };
};
